import React, { useState,useRef } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import testData from "../data/test.json";
import suitsData from "../data/suits.json";
import { useEffect } from "react";

export default function Test() {
  const [answers, setAnswers] = useState({});
  const [currentSlide, setCurrentSlide] = useState(0);
  const [result, setResult] = useState(null);
  const [showPipe, setShowPipe] = useState(false);

  const handleAnswerChange = (questionId, answerId) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: answerId,
    }));
    const nextIndex = testData.questions.findIndex(q => q.id === questionId) + 1;
    if (nextIndex < testData.questions.length) {
      setCurrentSlide(nextIndex);
    }
  };
  
  const sliderRef = useRef(null);
  const allCompleted = testData.questions.every(q => answers[q.id]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentSlide]);
  
  const handleSubmit = () => {
    let pointsC = 0, pointsD = 0, pointsH = 0, pointsS = 0;
  
    testData.questions.forEach(q => {
      const answerId = answers[q.id];
      const answer = q.answers.find(a => a.id === answerId);
      if (answer) {
        pointsC += Number(answer.results[0]);
        pointsD += Number(answer.results[1]);
        pointsH += Number(answer.results[2]);
        pointsS += Number(answer.results[3]);
      }
    });

    const totalC = pointsC;
    const totalD = pointsD;
    const totalH = pointsH;
    const totalS = pointsS;

    const sum = totalC + totalD + totalH + totalS;
    const valueC = ((totalC / sum) * 100).toFixed(2);
    const valueD = ((totalD / sum) * 100).toFixed(2);
    const valueH = ((totalH / sum) * 100).toFixed(2);
    const valueS = ((totalS / sum) * 100).toFixed(2);
  
    const suits = [
      { key: "tréboles", suit: suitsData["tréboles"].id, name: suitsData["tréboles"].title, description: suitsData["tréboles"].resultDesc, color: suitsData["tréboles"].color, value: valueC },
      { key: "diamantes", suit: suitsData["diamantes"].id, name: suitsData["diamantes"].title, description: suitsData["diamantes"].resultDesc, color: suitsData["diamantes"].color, value: valueD },
      { key: "corazones", suit: suitsData["corazones"].id, name: suitsData["corazones"].title, description: suitsData["corazones"].resultDesc, color: suitsData["corazones"].color, value: valueH },
      { key: "picas", suit: suitsData["picas"].id, name: suitsData["picas"].title, description: suitsData["picas"].resultDesc, color: suitsData["picas"].color, value: valueS }
    ];
    const jokerData = suitsData["joker"];
    
    suits.sort((a, b) => b.value - a.value);

    const allEqual = pointsC === pointsD && pointsC === pointsH && pointsC === pointsS;
    const topSuit = allEqual ? {suit: "joker", name: jokerData.name, description: jokerData.resultDesc } : suits[0];
  
    setResult({
      suits,
      topSuit,
    });
  };

const handleClosePopup = () => {
  setResult(null);
  setShowPipe(null);
};

useEffect(() => {
  if (result) {
    document.body.classList.add("popup-open");
  } else {
    document.body.classList.remove("popup-open");
  }

  return () => {
    document.body.classList.remove("popup-open");
  };
}, [result]);

  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>Test | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="test" className={`content ${result ? "popup-open" : ""}`}>
      <div className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Test</h1>
          <p className="subtitle">Descubre a qué palo perteneces con este test.</p>
        </div>
        <div className="content-main">
          {result && (
            <div id="popup" className="popup show" role="dialog" aria-labelledby="popup" aria-hidden="true">
                <div className={`popup-window ${result.topSuit.suit}`}>
                    <span className="popup-close" onClick={handleClosePopup}>×</span>
                    <div className="popup-background"></div>
                    <div className="popup-content">
                        <span className="suit-name">{result.topSuit.name}</span>
                        <div className="suit-content">
                            <div className="suit-description">
                              {result.topSuit.description.split("\n").map((line, index) => (
                                <React.Fragment key={index}>
                                  {line}
                                  <br />
                                </React.Fragment>
                              ))}
                            </div>
                            <span className={`chart-show ${showPipe? "show" : ""}`} onClick={() => {setShowPipe(v => !v)}}>Mostrar porcentajes</span>
                            <div className={`chart-result ${showPipe? "show" : ""}`}>
                                <div className="chart-pie" style={{ 
                                "--color1": result.suits[0].color, "--value1": `${result.suits[0].value}%`, 
                                "--color2": result.suits[1].color, "--value2": `${result.suits[1].value}%`,
                                "--color3": result.suits[2].color, "--value3": `${result.suits[2].value}%`,
                                "--color4": result.suits[3].color, "--value4": `${result.suits[3].value}%`}}></div>
                                <div className="chart-resume">
                                  {result.suits.map((s, i) => (
                                    <p key={i} style={{ color: s.color }}>
                                      {s.value}% {s.name}
                                    </p>
                                  ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
          <div id="slider" ref={sliderRef}>
            {Array.from({ length: testData.questions.length }, (_, i) => (
              <input key={i+1} className={answers[`q${i+1}`] ? "completed" : ""} type="radio" name="slider" id={`slide${i + 1}`} checked={currentSlide === i} onChange={() => setCurrentSlide(i)}              />
            ))}

            <form id="slides" method="post">
              <div className="inner">
                {testData.questions.map((q, i) => (
                    <div  key={q.id} className={`slide slide_${q.id}  ${answers[q.id] ? "completed" : ""}  ${currentSlide === i ? "active-slide" : ""}`}
                  >
                    <div className="slide-content">
                      <img className="test-img" src={`${process.env.PUBLIC_URL}${q.img}`} alt={q.alt}/>
                      <div className="test-content">
                        <div className="test-title title"><span className="test-number">{q.id}. </span>{q.title}</div>
                        <div className={`test-answers ${q.type}-type`}>
                          {q.answers.map((a) => (
                            <p key={a.id}>
                              <label htmlFor={`${q.id}_${a.id}`}>
                                <input type="radio" className="test-input" name={q.id} id={`${q.id}_${a.id}`} value={a.id} aria-label={`Respuesta ${a.id}`} checked={answers[q.id] === a.id} onChange={() => handleAnswerChange(q.id, a.id)}/>
                                <span className="letter">{a.id}</span>
                                <span className="answer">
                                  {q.type === "img" ? (
                                    <img src={`${process.env.PUBLIC_URL}${a.answer}`} alt={a.alt}/>
                                  ) : (
                                    <>
                                    {a.answer}
                                    </>
                                  )}
                                </span>
                            </label>
                            </p>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </form>
            <div className="bullets-content">
              <div className="bullets">
                {testData.questions.map((_, i) => (
                    <label key={i} className={`bullet ${currentSlide === i ? "active" : ""} ${answers[testData.questions[i].id] ? "completed" : ""}`} htmlFor={`slide${i+1}`} onClick={() => setCurrentSlide(i)} >{i+1}</label>
                  ))}
              </div>
            </div>
            <div id="submit-btn" style={{ display: allCompleted ? "block" : "none" }}>
              <button  className="btn btn-primary" htmlFor="submit-test" onClick={handleSubmit}>Enviar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}
